import { render, staticRenderFns } from "./DeliverGoodProductionReport.vue?vue&type=template&id=2917e616&"
import script from "./DeliverGoodProductionReport.vue?vue&type=script&lang=js&"
export * from "./DeliverGoodProductionReport.vue?vue&type=script&lang=js&"
import style0 from "./DeliverGoodProductionReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports